import { createSelector } from '@reduxjs/toolkit';

import { GlobalState } from '@/redux/store';

const stateSelector = (state: GlobalState) => state;
const storefrontSlice = createSelector(stateSelector, (state) => state.storefront);
const idSelector = (_: GlobalState, sellerId: number) => sellerId;

export const getIsLoadingStorefront = createSelector([storefrontSlice, idSelector], ({ loading }, sellerId) =>
    loading.includes(sellerId)
);

export const getStorefrontItemIds = createSelector(storefrontSlice, (state) => state.items);

export const getStorefrontAgentName = createSelector([storefrontSlice], ({ agentName }) => agentName ?? '');
